import React from 'react';
import './DateDisplay.css';

interface DateDisplayProps {
  date: Date;
  format?: 'short' | 'long' | 'relative';
  className?: string;
}

const DateDisplay: React.FC<DateDisplayProps> = ({ date, format = 'short', className = '' }) => {
  const formatDate = (date: Date, format: string) => {
    switch (format) {
      case 'short':
        return date.toLocaleDateString('en-IE', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      case 'long':
        return date.toLocaleDateString('en-IE', {
          weekday: 'short',
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      case 'relative':
        return getRelativeTime(date);
      default:
        return date.toLocaleDateString();
    }
  };

  const getRelativeTime = (date: Date): string => {
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
    
    if (diffInSeconds < 60) {
      return 'Just now';
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes}m ago`;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours}h ago`;
    } else if (diffInSeconds < 604800) {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days}d ago`;
    } else {
      return date.toLocaleDateString('en-IE', {
        day: '2-digit',
        month: 'short'
      });
    }
  };

  return (
    <span className={`date-display ${className}`} title={date.toLocaleString()}>
      {formatDate(date, format)}
    </span>
  );
};

export default DateDisplay;
